import { Input } from "@heroui/react";
import InputSkeleton from "shared/skeletons/input.skeleton";
import { FieldType } from "shared/types/field";
import { MaskOptions, applyMask } from "shared/utils/masks";

interface EditableInputProps {
  editMode: boolean;
  value: string;
  type?: FieldType;
  onChange: (value: string) => void;
  onBlur?: () => void;
  indentation?: string;
  isLoading?: boolean;
  label?: string; // Add label to the props
  children?: React.ReactNode;
  mask?: string;
  ref?: any;
}

export const EditableInputComponent: React.FC<EditableInputProps> = ({
  editMode,
  value,
  type = FieldType.DEFAULT,
  indentation = "",
  onChange,
  onBlur,
  isLoading = true,
  label, // Destructure label from props
  children,
  mask = "",
  ref = null,
}) => {
  const displayValue = value != null && value != undefined ? applyMask(value, mask as MaskOptions) : null;

  if (isLoading) return <InputSkeleton />;
  if (editMode) {
    return (
      <Input ref={ref}
        label={label}
        labelPlacement="inside"
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        value={value}
        classNames={{
          input:
            "text-neutral-primary placeholder:text-neutral-secondary-mid pt-2.5",
          inputWrapper:
            "p-2 min-h-fit h-fit rounded-sm bg-white shadow-form-element! data-[hover=true]:bg-white group-data-[focus=true]:bg-white data-[hover=true]:shadow-form-element-hv! group-data-[focus=true]:shadow-form-element-fc!",
        }}
      />
    );
  }
  // If children are provided, render them. Otherwise, default to the <p> tag.
  return (
    children ||
    (type == FieldType.DEFAULT ? (
      <p className={`font-medium ${indentation ? ("ml-" + indentation) : ""}`}>
        {displayValue !== null && displayValue !== undefined ? displayValue : "Niet ingevuld"}
      </p>
    ) : type == FieldType.EMAIL ? (
      <a
        href={"mailto:" + displayValue}
        className="font-medium text-moss-primary"
      >
        {displayValue !== null && displayValue !== undefined ? displayValue : "Niet ingevuld"}
      </a>
    ) : type == FieldType.PHONE ? (
      <a href={"tel:" + displayValue} className="font-medium text-moss-primary">
        {displayValue !== null && displayValue !== undefined ? displayValue : "Niet ingevuld"}
      </a>
    ) : type == FieldType.CONTACT ? (
      <a href={"tel:" + displayValue} className="font-medium text-moss-primary">
        {displayValue !== null && displayValue !== undefined ? displayValue : "Niet ingevuld"}
      </a>
    ) : (
      <p className={`font-medium ${indentation ? ("ml-" + indentation) : ""}`}>
        {displayValue !== null && displayValue !== undefined ? displayValue : "Niet ingevuld"}
      </p>
    ))
  );
  
};
